export default "__VITE_ASSET__D2Dy24c0__"